import { CUSTOMER_JOURNEY_SERVICES_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_SERVICES_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyServicesError.js